export default __webpack_public_path__ + "static/media/service_2.a6c5c07c.png";